import { FETCH_METRICS_REQUEST, FETCH_METRICS_ERROR, FETCH_METRICS_RESPONSE } from './actionTypes';
import { fetchMetricsRequest, fetchMetricsResponse, fetchMetricsError } from './actions';
import { MetricReducer } from './types';

type MetricReducerActionType =
  | ReturnType<typeof fetchMetricsRequest>
  | ReturnType<typeof fetchMetricsResponse>
  | ReturnType<typeof fetchMetricsError>;

export const initialMetricsReducerState = {
  highLevelMetrics: [],
  loadingHighLevelMetrics: false,
};

const metricsReducer = (
  state: MetricReducer = initialMetricsReducerState,
  action: MetricReducerActionType,
) => {
  switch (action.type) {
    case FETCH_METRICS_REQUEST:
      return {
        ...state,
        loadingHighLevelMetrics: true,
      };
    case FETCH_METRICS_RESPONSE:
      return {
        ...state,
        loadingHighLevelMetrics: false,
        highLevelMetrics: action.metrics,
      };
    case FETCH_METRICS_ERROR:
      return {
        ...state,
        highLevelMetricsErrorMessage: action.error.toString(),
        loadingHighLevelMetrics: false,
      };
    default:
      return state;
  }
};

export default metricsReducer;
